import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import { getFaroProxyConfig } from '../../config/panda-configuration';
import SettingConfig from '../../config/setting';

let isFaroInitialized = false;

const toPathname = (urlOrPath: string): string => {
  try {
    return new URL(urlOrPath, window.location.origin).pathname || '/';
  } catch {
    return urlOrPath.split('?')[0]?.split('#')[0] || '/';
  }
};

export const getBoundedRouteName = (urlOrPath: string): string => {
  const [route] = toPathname(urlOrPath).split('/').filter(Boolean);
  return route ? `/${route}` : '/';
};

export const initializeFrontendFaro = (): boolean => {
  if (typeof window === 'undefined' || isFaroInitialized) {
    return false;
  }
  const faroProxyConfig = getFaroProxyConfig();
  const faroUrl = new URL(faroProxyConfig.source, window.location.origin).toString();

  const faroInstance = initializeFaro({
    url: faroUrl,
    app: {
      name: SettingConfig.environment,
      version: SettingConfig.SHORT_SHA,
      environment: SettingConfig.environment,
    },
    experimental: { trackNavigation: true },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: false,
        enablePerformanceInstrumentation: true,
        enableContentSecurityPolicyInstrumentation: true,
      }),
      new TracingInstrumentation({
        // Disable fetch/XHR instrumentation: we don't want per-request spans or their
        // corresponding Faro events reaching Loki. Trace context (traceId on page/session)
        // is still exported to Tempo via the OTel provider.
        instrumentations: [],
        resourceAttributes: { 'deployment.environment': SettingConfig.environment },
      }),
    ],
    pageTracking: {
      generatePageId: (location) => getBoundedRouteName(location.pathname),
    },
    sessionTracking: { persistent: true, samplingRate: faroProxyConfig.sessionSampleRate },
  });

  isFaroInitialized = Boolean(faroInstance);
  return isFaroInitialized;
};

export const setFrontendRoute = (urlOrPath: string) => {
  if (typeof window === 'undefined') return;
  faro.api.setView({ name: getBoundedRouteName(urlOrPath) });
};
